"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Column(props) {
    return null;
}
// import React from "react";


Column.propTypes = {
    spread: _propTypes2.default.func,
    spreadParams: _propTypes2.default.object,
    spreadTitle: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Column;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/Column.js
// module id = 279
// module chunks = 0